import { useReactiveVar } from '@apollo/client';
import { useCallback, useEffect } from 'react';

import THEME_STATE, { LOCALSTORAGE_THEME_KEY, TThemeState } from '@/constants/theme';
import { appTheme } from '@/services/apollo/vars';

export type TThemeOptions = 'light' | 'dark';

export const updateHtmlTheme = (isDarkMode: boolean) => {
	const elem = document.querySelector('html') as HTMLElement;
	const classList = elem.classList;
	classList.remove('dark');

	elem.className = `${elem.classList} ${isDarkMode ? 'dark' : ''}`;
};

const useThemeState = () => {
	const appThemeVar = useReactiveVar(appTheme);
	const isDarkMode = useCallback(() => appThemeVar === THEME_STATE.DARK, [appThemeVar]);

	const setTheme = useCallback((newTheme: TThemeState) => {
		appTheme(newTheme);
		localStorage.setItem(LOCALSTORAGE_THEME_KEY, newTheme);
	}, []);

	useEffect(() => {
		if (appThemeVar === null) {
			setTheme(
				(typeof localStorage !== 'undefined' ? (localStorage.getItem(LOCALSTORAGE_THEME_KEY) as TThemeState) : null) ||
					'dark'
			);
		}
		updateHtmlTheme(appThemeVar === THEME_STATE.DARK);
	}, [appThemeVar, setTheme]);

	return {
		isDarkMode,
		theme: appThemeVar,
		setTheme,
	};
};

export default useThemeState;
